var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupKnockout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 6.75H4.75M18.75 6.75H21.75V12.75H18.75M18.75 6.75V2.75C18.75 1.64543 17.8546 0.75 16.75 0.75H2.75C1.64543 0.75 0.75 1.64543 0.75 2.75V6.75H4.75M18.75 12.75H4.75M18.75 12.75V16.75C18.75 17.8546 17.8546 18.75 16.75 18.75H2.75C1.64543 18.75 0.75 17.8546 0.75 16.75V12.75H4.75M4.75 6.75V12.75",
    stroke: "#8C8C8C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupKnockout);
export default __webpack_public_path__ + "static/media/group-knockout.a005a3a8d89199ddd7c8fbb7e9ecd44a.svg";
export { ForwardRef as ReactComponent };